import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import OrderStatusCancelOrderButton from '../../components/OrderStatusCancelOrderButton';

import {
  resetInteraction,
  requestInteraction,
  setOrderHelpModalIsOpen,
  setOrderHelpModalPage,
  setIsSpecificHelpPage,
} from '../../actions/orderActions';

export function OrderStatusCancelOrderButtonContainer({
  orderId,
  statusButtonText,
  actionId,
  actionTemplate,
  selectedActionId,
  selectedActionTemplate,
  openOrderHelpModal,
}) {
  return (
    <OrderStatusCancelOrderButton
      orderId={orderId}
      statusButtonText={statusButtonText}
      actionId={actionId}
      actionTemplate={actionTemplate}
      selectedActionId={selectedActionId}
      selectedActionTemplate={selectedActionTemplate}
      openOrderHelpModal={openOrderHelpModal}
    />
  );
}

OrderStatusCancelOrderButtonContainer.defaultProps = {
  openOrderHelpModal: () => {},
};

OrderStatusCancelOrderButtonContainer.propTypes = {
  /** Id of the order */
  orderId: PropTypes.string.isRequired,
  /** The text of the button */
  statusButtonText: PropTypes.string.isRequired,
  actionId: PropTypes.string.isRequired,
  actionTemplate: PropTypes.string.isRequired,
  selectedActionId: PropTypes.string.isRequired,
  selectedActionTemplate: PropTypes.string.isRequired,
  /**
   * Action to open the OrderHelpModal
   */
  openOrderHelpModal: PropTypes.func,
};

const mapStateToProps = ({ order, request }) => {
  const statusButton = order.status.attributes.statusButton;

  return {
    // Get the orderId from the url query so we're not reliant on fetching the order
    orderId: request.currentQuery.orderId,
    statusButtonText: statusButton.text,
    actionId: statusButton.uriQueries.actionId,
    actionTemplate: statusButton.uriQueries.actionTemplate,
    selectedActionId: statusButton.uriQueries.selectedActionId,
    selectedActionTemplate: statusButton.uriQueries.selectedActionTemplate,
  };
};

const mapActionsToProps = (dispatch) => ({
  openOrderHelpModal: (...args) => {
    dispatch(resetInteraction());
    dispatch(setIsSpecificHelpPage(true));
    dispatch(setOrderHelpModalPage(...args));
    dispatch(requestInteraction());
    dispatch(setOrderHelpModalIsOpen(true));
  },
});

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(OrderStatusCancelOrderButtonContainer);
